import { Group, UnstyledButton } from '@mantine/core';

import { ChevronDownIconSm, ChevronUpDownIconSm, ChevronUpIconSm } from '@chownow/pantry/icons';

import { Filters } from 'types/ordersList';

interface TableHeaderProps {
  handleOnSort: (labelKey: string) => void;
  filters: Filters;
  label: string;
  labelKey: string;
}

export default function TableHeader({ filters, handleOnSort, label, labelKey }: TableHeaderProps) {
  const isActive = filters.order_by === labelKey;
  const isAsc = filters.sort_order === 'asc';

  let sortIcon = <ChevronUpDownIconSm style={{ color: 'var(--content-secondary)' }} />;
  if (isActive) {
    sortIcon = isAsc ? (
      <ChevronUpIconSm style={{ color: 'var(--content-primary)' }} />
    ) : (
      <ChevronDownIconSm style={{ color: 'var(--content-primary)' }} />
    );
  }

  return (
    <UnstyledButton variant="table-header" onClick={() => handleOnSort(labelKey)}>
      <Group gap="xs2" wrap="nowrap">
        {sortIcon}
        {label}
      </Group>
    </UnstyledButton>
  );
}
